import React from "react";
import { Link } from "react-router-dom";
import Moment from "react-moment";

const EmployerNotificationItem = ({
  notification,
  deleteNotification,
  setnotificationsOpen,
}) => {
  return (
    <div className={notification.unread ? "notification blue" : "notification"}>
      {notification.type === "giftedcourse" && (
        <div className="single-notification">
          <Link
            to={`/${notification.channelid}`}
            onClick={() => setnotificationsOpen(false)}
          >
            <div className="notif-avi-container">
              <img
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${notification.avatar}`}
                className="notif-avi"
              />
            </div>
          </Link>
          <div className="notification-text blue">
            <div className="notification-type">
              <i className="fas fa-gift mx-5 blue"></i>
              Gifted Course
            </div>
            <div className="notification-text-title">
              Lorem ipsum dolor sit amet consectetur, adipisicing elit. or ime
              monthly courses.
            </div>
            <div className="notification-user blue">Gifted from User Name</div>
            <div className="notification-date">
              <i className="far fa-clock mx-5 blue"></i>
              <Moment format="MM/DD/YYYY">{notification.date}</Moment>
            </div>
          </div>
          <div
            onClick={() => deleteNotification(notification._id)}
            className="remove-notification"
          >
            <i className="fas fa-times blue"></i>
          </div>
        </div>
      )}
      {notification.type === "giftedsubscription" && (
        <div className="single-notification">
          <Link
            to={`/${notification.channelid}`}
            onClick={() => setnotificationsOpen(false)}
          >
            <div className="notif-avi-container">
              <img
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${notification.avatar}`}
                className="notif-avi"
              />
            </div>
          </Link>
          <div className="notification-text blue">
            <div className="notification-type">
              <i className="fas fa-gift mx-5 blue"></i>
              Gifted Subscription
            </div>
            <div className="notification-text-title">
              One month subscription to Mentor Name or ime subscription
            </div>
            <div className="notification-user blue">Gifted from User Name</div>
            <div className="notification-date">
              <i className="far fa-clock mx-5 blue"></i>
              <Moment format="MM/DD/YYYY">{notification.date}</Moment>
            </div>
          </div>
          <div
            onClick={() => deleteNotification(notification._id)}
            className="remove-notification"
          >
            <i className="fas fa-times blue"></i>
          </div>
        </div>
      )}
      {notification.type === "acceptedcasualrequest" && (
        <div className="single-notification">
          <Link
            to={`/${notification.channelid}`}
            onClick={() => setnotificationsOpen(false)}
          >
            <div className="notif-avi-container">
              <img
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${notification.avatar}`}
                className="notif-avi"
              />
            </div>
          </Link>
          <div className="notification-text blue">
            <div className="notification-type">
              <i className="fas fa-user-friends mx-5 blue"></i>
              Accepted Friend Request
            </div>
            <div className="notification-text-title">
              <span className="blue bold">
                {notification.firstname} {notification.lastname}
              </span>{" "}
              added you as a <span className="blue bold">Casual</span> Friend.
            </div>
            <div className="notification-date">
              <i className="far fa-clock mx-5 blue"></i>
              <Moment format="MM/DD/YYYY">{notification.date}</Moment>
            </div>
          </div>
          <div
            onClick={() => deleteNotification(notification._id)}
            className="remove-notification"
          >
            <i className="fas fa-times blue"></i>
          </div>
        </div>
      )}
      {notification.type === "acceptedapproval" && (
        <div className="single-notification">
          <Link
            to={`/${notification.channelid}`}
            onClick={() => setnotificationsOpen(false)}
          >
            <div className="notif-avi-container">
              <img
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${notification.avatar}`}
                className="notif-avi"
              />
            </div>
          </Link>
          <div className="notification-text blue">
            <div className="notification-type">
              <i className="fas fa-file-signature mx-5 blue"></i>
              Accepted Approval Request
            </div>
            <div className="notification-text-title">
              <span className="blue bold">
                {notification.firstname} {notification.lastname}
              </span>{" "}
              accepted your <span className="blue bold">Approval</span> request.
            </div>
            <div className="notification-date">
              <i className="far fa-clock mx-5 blue"></i>
              <Moment format="MM/DD/YYYY">{notification.date}</Moment>
            </div>
          </div>
          <div
            onClick={() => deleteNotification(notification._id)}
            className="remove-notification"
          >
            <i className="fas fa-times blue"></i>
          </div>
        </div>
      )}
      {notification.type === "friends" && (
        <div className="single-notification">
          <Link
            to={`/${notification.channelid}`}
            onClick={() => setnotificationsOpen(false)}
          >
            <div className="notif-avi-container">
              <img
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${notification.avatar}`}
                className="notif-avi"
              />
            </div>
          </Link>
          <div className="notification-text blue">
            <div className="notification-type">
              <i className="fas fa-user-friends mx-5 blue bold"></i>
              Received Friend Request
            </div>
            <div className="notification-text-title">
              <span className="blue bold">
                {notification.firstname} {notification.lastname}
              </span>{" "}
              sent you a Friend request.
            </div>
            <div className="notification-date">
              <i className="far fa-clock mx-5 blue"></i>
              <Moment format="MM/DD/YYYY">{notification.date}</Moment>
            </div>
          </div>
          <div
            onClick={() => deleteNotification(notification._id)}
            className="remove-notification"
          >
            <i className="fas fa-times blue"></i>
          </div>
        </div>
      )}
      {notification.type === "expiringmentorsubscription" && (
        <div className="single-notification">
          <Link
            to={`/${notification.channelid}`}
            onClick={() => setnotificationsOpen(false)}
          >
            <div className="notif-avi-container">
              <img
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${notification.avatar}`}
                className="notif-avi"
              />
            </div>
          </Link>
          <div className="notification-text blue">
            <div className="notification-type">
              <i className="fas fa-user-check mx-5 blue"></i>
              Expiring Subscription
            </div>
            <div className="notification-text-title">
              Your subscription to Mentor Name expires in number days.
              <span className="blue cursor mx-5 bold">Resubscribe</span>?
            </div>
            <div className="notification-date">
              <i className="far fa-clock mx-5 blue"></i>
              <Moment format="MM/DD/YYYY">{notification.date}</Moment>
            </div>
          </div>
          <div
            onClick={() => deleteNotification(notification._id)}
            className="remove-notification"
          >
            <i className="fas fa-times blue"></i>
          </div>
        </div>
      )}
      {notification.type === "discussioninvite" && (
        <div className="single-notification">
          <Link
            to={`/${notification.channelid}`}
            onClick={() => setnotificationsOpen(false)}
          >
            <div className="notif-avi-container">
              <img
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${notification.avatar}`}
                className="notif-avi"
              />
            </div>
          </Link>
          <div className="notification-text blue">
            <div className="notification-type">
              <i className="fas fa-video mx-5 blue"></i>
              Live Discussion
            </div>
            <div className="notification-text-title">
              User's name invited you to view a live discussion
              <span className="blue cursor mx-5 bold">Join Now</span>
            </div>
            <div className="notification-date">
              <i className="far fa-clock mx-5 blue"></i>
              <Moment format="MM/DD/YYYY">{notification.date}</Moment>
            </div>
          </div>
          <div
            onClick={() => deleteNotification(notification._id)}
            className="remove-notification"
          >
            <i className="fas fa-times blue"></i>
          </div>
        </div>
      )}
      {notification.type === "livestream" && (
        <div className="single-notification">
          <Link
            to={`/${notification.channelid}`}
            onClick={() => setnotificationsOpen(false)}
          >
            <div className="notif-avi-container">
              <img
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${notification.avatar}`}
                className="notif-avi"
              />
            </div>
          </Link>
          <div className="notification-text blue">
            <div className="notification-type">
              <i className="fas fa-video mx-5 blue"></i>
              Live Stream
            </div>
            <div className="notification-text-title">
              User name just went live!
              <span className="blue cursor mx-5 bold">Watch Now</span>
            </div>
            <div className="notification-date">
              <i className="far fa-clock mx-5 blue"></i>
              <Moment format="MM/DD/YYYY">{notification.date}</Moment>
            </div>
          </div>
          <div
            onClick={() => deleteNotification(notification._id)}
            className="remove-notification"
          >
            <i className="fas fa-times blue"></i>
          </div>
        </div>
      )}
      {notification.type === "sharedarticle" && (
        <div className="single-notification">
          <Link
            to={`/${notification.channelid}`}
            onClick={() => setnotificationsOpen(false)}
          >
            <div className="notif-avi-container">
              <img
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${notification.avatar}`}
                className="notif-avi"
              />
            </div>
          </Link>
          <div className="notification-text blue">
            <div className="notification-type">
              <i className="far fa-newspaper mx-5 blue"></i>
              Shared Article
            </div>
            <div className="notification-text-title">
              User's name shared Innovator's article with you.
              <span className="blue cursor mx-5 bold">View Now</span>
            </div>
            <div className="notification-date">
              <i className="far fa-clock mx-5 blue"></i>
              <Moment format="MM/DD/YYYY">{notification.date}</Moment>
            </div>
          </div>
          <div
            onClick={() => deleteNotification(notification._id)}
            className="remove-notification"
          >
            <i className="fas fa-times blue"></i>
          </div>
        </div>
      )}
      {notification.type === "expiringsubscription" && (
        <div className="single-notification">
          <Link
            to={`/${notification.channelid}`}
            onClick={() => setnotificationsOpen(false)}
          >
            <div className="notif-avi-container">
              <img
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${notification.avatar}`}
                className="notif-avi"
              />
            </div>
          </Link>
          <div className="notification-text blue">
            <div className="notification-type">
              <i className="fas fa-medal mx-5 blue"></i>
              Expiring Subscription
            </div>
            <div className="notification-text-title">
              Your subscription
              <span className="blue mx-5 bold">Subscription Name</span>
              expires in 7 days. Would you like to
              <span className="blue mx-5 cursor bold">Renew</span>?
            </div>
            <div className="notification-date">
              <i className="far fa-clock mx-5 blue"></i>
              <Moment format="MM/DD/YYYY">{notification.date}</Moment>
            </div>
          </div>
          <div
            onClick={() => deleteNotification(notification._id)}
            className="remove-notification"
          >
            <i className="fas fa-times blue"></i>
          </div>
        </div>
      )}
      {notification.type === "follower" && (
        <div className="single-notification">
          <Link
            to={`/${notification.channelid}`}
            onClick={() => setnotificationsOpen(false)}
          >
            <div className="notif-avi-container">
              <img
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${notification.avatar}`}
                className="notif-avi"
              />
            </div>
          </Link>
          <div className="notification-text blue">
            <div className="notification-type">
              <i className="fas fa-check mx-5 blue"></i>
              New Follower
            </div>
            <div className="notification-text-title">
              <span className="blue bold">
                {notification.firstname} {notification.lastname}
              </span>{" "}
              followed you.
            </div>
            <div className="notification-date">
              <i className="far fa-clock mx-5 blue"></i>
              <Moment format="MM/DD/YYYY">{notification.date}</Moment>
            </div>
          </div>
          <div
            onClick={() => deleteNotification(notification._id)}
            className="remove-notification"
          >
            <i className="fas fa-times blue"></i>
          </div>
        </div>
      )}
    </div>
  );
};

export default EmployerNotificationItem;
